export type IndividualCitationAuthor = {
  given: string;
  family: string;
  suffix?: string;
};

export type OrganisationCitationAuthor = {
  literal: string;
};

export type CitationAuthor =
  | IndividualCitationAuthor
  | OrganisationCitationAuthor;

type CitationBase = {
  type: CitationTypes;
  author: CitationAuthor[];
  title: string;
  issued?: string;
};

export type CslEndNoteCitation =
  | BookFields
  | JournalArticleFields
  | GenericFields
  | BookSectionFields
  | ConferencePaperFields
  | WebpageFields
  | ReportFields
  | PlainCitationFields;

export type CslEndNoteCitationUnion = BookFields &
  JournalArticleFields &
  GenericFields &
  BookSectionFields &
  ConferencePaperFields &
  WebpageFields &
  ReportFields &
  PlainCitationFields;

export type BookFields = CitationBase & {
  edition?: string;
  publisherPlace?: string;
  publisher?: string;
  numberOfPages?: string;
  seriesEditor?: string;
};

export type JournalArticleFields = CitationBase & {
  'container-title'?: string;
  'container-title-short'?: string;
  volume?: string;
  issue?: string;
  page?: string;
  DOI?: string;
};

export type GenericFields = CitationBase & {
  edition?: string;
  publisherPlace?: string;
  publisher?: string;
  pages?: string;
  accessed?: string;
  url?: string;
};

export type BookSectionFields = CitationBase & {
  edition?: string;
  publisherPlace?: string;
  publisher?: string;
  page?: string;
  bookSectionTitle?: string;
  editors?: string;
  volume?: string;
};

export type ConferencePaperFields = CitationBase & {
  publisherPlace?: string;
  publisherName?: string;
  page?: string;
  editors?: string;
  eventName?: string;
  eventPlace?: string;
};

export type ReportFields = CitationBase & {
  genre?: string;
  publisherPlace?: string;
  publisher?: string;
  number?: string;
  documentNumber?: string;
  reportNumber?: string;
};

export type WebpageFields = CitationBase & {
  typeOfMedium?: string;
  publisherPlace?: string;
  publisher?: string;
  accessed?: string;
  edition?: string;
  note?: string;
  url?: string;
};

export interface PlainCitationFields {
  type: string;
  plainText: string;
}

export enum CitationTypes {
  BOOK = 'book',
  GENERIC = 'Generic',
  BOOK_SECTION = 'chapter',
  CONFERENCE_PAPER = 'paper-conference',
  JOURNAL_ARTICLE = 'article-journal',
  REPORT = 'report',
  WEBPAGE = 'webpage',
  PLAIN = 'plain',
}
